import {App} from './App'
import {SearchEntrypoint} from './pages/Search'
import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {blackbirdSearchAppBuilder} from './config/app-builder'
import {blackbirdSearchRoute} from './routes/search-route'

export const blackbirdSearchApp = blackbirdSearchAppBuilder.createDataRouterAppFromRoutes([
  {
    Component: App,
    children: [
      blackbirdSearchRoute.toRoute({
        Component: SearchEntrypoint,
      }),
    ],
  },
])
registerDataRouterApp(blackbirdSearchApp)
